import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import styled, { css } from 'styled-components/macro';
import { chevrone } from '../../../../../assets/icons';

export const AddPhoneWrapper = styled.div<{ $isError?: boolean }>`
  ${({ theme, $isError }) => css`
    display: flex;
    align-items: center;
    min-width: 180px;
    height: 40px;
    background: transparent;
    border: 1px solid
      ${$isError ? theme.colors.red[500] : theme.colors.gray[300]};
    border-radius: ${theme.radiuses.xs};

    input {
      padding-inline: ${theme.spacings.s};
      flex: 1;
      min-width: 0;
      height: 100%;
      background: transparent;
      color: ${theme.colors.gray[800]};
      border: none;
      outline: none;
      ${theme.fonts['body-14'].css}
    }

    button {
      padding-inline: ${theme.spacings.xs};
      display: flex;
      flex-shrink: 0;
      align-items: center;
      color: ${theme.colors.gray[400]};
      border: none;
      background: none;
      cursor: pointer;

      &:hover {
        color: ${theme.colors.gray[500]};
      }
    }
  `}
`;

export const ErrorRow = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xxs};
    color: ${theme.colors.red[500]};
    ${theme.fonts['body-14'].css};
  `}
`;

export const PhoneWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  align-items: center;
`;

export const MailWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ChevronIcon = styled.img.attrs({ src: chevrone })<{
  isOpen: boolean;
}>`
  transform: ${(props) => (props.isOpen ? 'rotate(180deg)' : 'none')};
  cursor: pointer;
  width: 16px;
  height: 16px;
`;

export const StyledSpan = styled.span`
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const Trigger = styled(DropdownMenu.Trigger)`
  padding: 0;
  outline: none;
  border: none;
  background-color: inherit;
`;

export const Content = styled(DropdownMenu.Content)`
  z-index: 99999;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #ced5de;
  border-radius: 8px;
  padding: 4px 0;
  box-shadow:
    0 2px 4px 0 rgba(15, 23, 40, 0.04),
    0 4px 8px 0 rgba(15, 23, 40, 0.12),
    0 0 10px 6px rgba(15, 23, 40, 0.04);
`;

export const ScrollWrapper = styled.div`
  max-height: 150px;
  overflow-y: auto;
`;

export const Item = styled(DropdownMenu.Item)`
  display: flex;
  gap: 10px;
  align-items: center;
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  transition: all 150ms;
  padding: 10px 12px;
  cursor: default;
  border: none;
  outline: none;
`;

export const AddItem = styled(DropdownMenu.Item)<{ isDisable: boolean }>`
  margin: 4px 8px;
  padding: 4px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  text-align: center;
  border-radius: 6px;
  background-color: #f2f5f8;
  color: #1f2939;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  opacity: ${(props) => (props.isDisable ? '0.5' : '1')};
  cursor: pointer;
  border: none;
  outline: none;

  :hover {
    background-color: #e4e8ee;
  }
`;
